import { TLatestPost } from './types'
import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '..'
import { TPost } from '../managePost/types'

export const getPostsForInstaGridViewThunk = createAsyncThunk(
  'gridView/getPostsForInstaGridViewThunk',
  async (data, { rejectWithValue, getState }) => {
    const {
      project: {
        currentProject: { id }
      }
    } = getState() as RootState
    try {
      const response: AxiosResponse<any> = await axios.get(`projects/${id}/instagram-posts-grid`)
      return response.data.data.filter(
        (post: TLatestPost) => post?.post?.latest_schedule || post.instagramMedia
      )
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)
